/**
 * Normalises an email address for comparison only — never for sending.
 *
 * Reporters routinely retype the same address with different casing or a stray
 * trailing space, and both the "you already shared this address" warning and the
 * per-address verification cache must treat those as the same address.
 */
export const normaliseEmail = (email?: string | null) =>
    email?.trim().toLowerCase() ?? '';

export const isSameEmail = (a?: string | null, b?: string | null) => {
    const left = normaliseEmail(a);

    return !!left && left === normaliseEmail(b);
};
